import * as z from "zod";

export const getReviewsAverageByProject = {
  name: "getReviewsAverageByProject" as const,
  input: z.object({
    teamId: z.string(),
    sort: z.object({ direction: z.string(), key: z.string() }).optional(),
    search: z.string().optional(),
    page: z.optional(z.number().positive().int()),
    pageSize: z.optional(z.number().positive().int()),
  }),
  output: z.object({
    products: z.array(
      z.object({
        productName: z.string(),
        productDescription: z.string(),
        productImageSrc: z.string(),
        team: z.string(),
        shopifyProductId: z.string(),
        numberOfReviews: z.number(),
        numberOfStars: z.number(),
      }),
    ),
    totalCount: z.number().int(),
  }),
};
